import React from 'react';
import { Paper, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';

import useHomeStyles from '../../../../../constants/homeStyles';
import { useDefineUserRole, useFormatMessage } from '../../../../../hooks';
import { setLayoutSubheader, setLayoutFooter } from '../../../../../utils/layout';
import { ModerationList } from './ModerationList';
import { IAppState } from '../../../../../store/rootDuck';
import { ErrorsFiles } from './ErrorsFiles';
import { NoErrorsFiles } from './NoErrorsFiles';

export function OffersList() {
  const fm = useFormatMessage();
  const [tabValue, setTabValue] = React.useState(0);
  const { classes: classesHome } = useHomeStyles();
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const isManager = useDefineUserRole(me, ['ROLE_MANAGER']);

  setLayoutSubheader({
    title: fm('PRICES.MODERATION'),
  });
  setLayoutFooter({ show: true });

  if (!me?.is_admin && !isManager) return null;

  return (
    <Paper className={classesHome.container}>
      <Tabs
        value={tabValue}
        onChange={(_: React.ChangeEvent<{}>, newValue: number) => {
          setTabValue(newValue);
        }}
        indicatorColor='primary'
        textColor='primary'
      >
        <Tab label={fm('PRICE.MODERATION.TAB.NEW')} />
        <Tab label={fm('PRICE.MODERATION.TAB.ATTENTION')} />
        <Tab label={fm('IMPORTS.WITHOUT.ERROR')} />
      </Tabs>
      <div style={{ display: tabValue === 0 ? 'contents' : 'none' }}>
        <ModerationList />
      </div>
      <div style={{ display: tabValue === 1 ? 'contents' : 'none' }}>
        <ErrorsFiles />
      </div>
      <div style={{ display: tabValue === 2 ? 'contents' : 'none' }}>
        <NoErrorsFiles />
      </div>
    </Paper>
  );
}
